import Http from '_u/request'
import { Toast } from 'vant'

const requireModules = require.context('./', true, /^\.\/.*\/index\.js$/)
const apiList = {}
requireModules.keys().forEach(path => {
  const apiObj = requireModules(path).default
  const a = Object.keys(apiObj).length
  const b = Object.keys(apiList).length
  Object.assign(apiList, apiObj)
  const c = Object.keys(apiList).length
  if (c !== a + b) throw `${path}中存在重复的api`
})

const http = new Http()
// 请求等待列队
const queue = {}
// 请求对象
const Request = {}

for (const key in apiList) {
  Request[key] = async (params = {}) => {
    const { apiLoading, apiReject, ...parameters } = params
    let res = null
    const url = apiList[key].url

    // 请求等待
    if (apiLoading) {
      queue[url] = Toast.loading({
        message: typeof apiLoading === 'string' ? apiLoading : '加载中...',
        forbidClick: true,
        duration: 0,
        loadingType: 'spinner'
      })
    }
    try {
      res = await http.request({ ...apiList[key], parameters })
    } catch (err) {
      res = err
    } finally {
      // 请求等待结束
      if (queue[url]) {
        queue[url].clear()
        delete queue[url]
      }
    }

    if (
      (!apiReject || (typeof apiReject === 'number' && res.retCode !== apiReject)) &&
      res.retCode !== '000'
    ) {
      Toast.fail(res.message || res.msg)
    }
    const defaultConfig = http.config()
    const logParams = {
      请求参数: params,
      请求配置: {
        ...defaultConfig,
        ...apiList[key],
        header: { ...defaultConfig.header, ...apiList[key].header }
      }
    }
    if (res.retCode === '000') console.log(`${apiList[key].title}成功`, res, logParams)
    else console.error(`${apiList[key].title}失败`, res, logParams)
    return res
  }
}

export default Request
